import { action, observable, makeObservable } from 'mobx';

export enum Severity {
    NONE = '',
    LOW = 'low',
    MEDIUM = 'medium',
    HIGH = 'high'
}

export enum ExtensionType {
    COLLECTION = 'collection',
    RESPONSE = 'response'
}

export interface IExtension {
    id?: string;
    name: string;
    description?: string;
    body?: string;
    severity?: string;
    type?: string;
    language?: string;
    adminOnly?: boolean;
    active?: boolean;
    isDefault?: boolean;
    sourceVersion?: string | null;
    sourceUrl?: string;
}

export default class ExtensionStore {
    extension = {
        id: '',
        name: ''
    };

    constructor(extension?: IExtension) {
        makeObservable(this, {
            extension: observable,
            update: action
        });

        this.update(extension);
    }

    update(extension?: IExtension): void {
        this.extension = {
            ...this.extension,
            ...extension
        };
    }
}
